import React, {useState, createContext} from 'react'

export const SectionContext = createContext()

export const SectionProvider = (props) => {
    const[sectionState, setSectionState] = useState({
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {}
    })
    return (
        <SectionContext.Provider value={[sectionState,setSectionState]}>
            {props.children}
        </SectionContext.Provider>
    )
}
